import { auth } from "../firebase";
import ENV from "../env";

const requestPromoCodeChange = async (path, payload) => {
  const token = await auth.currentUser?.getIdToken();
  if (!token) throw new Error("Authentication required");

  const response = await fetch(`${ENV.firebaseApiUrl}/ticketing/promo-codes/${path}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(data?.error || "Promo code update failed");
  return data;
};

export const saveTicketingPromoCode = ({ eventId, orgId, promoCode }) =>
  requestPromoCodeChange("save", { eventId, orgId, promoCode });

export const deleteTicketingPromoCode = ({ eventId, orgId, promoCodeId }) =>
  requestPromoCodeChange("delete", { eventId, orgId, promoCodeId });
